import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SecurityConfigService} from '@twpub/shared/services/security-config.service';
import {KeycloakService} from 'keycloak-angular';
import {NGXLogger} from 'ngx-logger';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-keycloak-auth',
  standalone: true,
  template: ''
})
export class KeycloakAuthComponent implements OnInit {
  constructor(
    private logger: NGXLogger, private securityService: SecurityConfigService, private router: Router,
    private keycloakService: KeycloakService
  ) {
  }

  async ngOnInit() {
    const config = this.securityService.getConfig();
    if (config.keycloakEnabled) {
      await this.authenticateWithKeycloak();
    } else {
      this.logger.debug('KeycloakAuthComponent.ngOnInit: Keycloak not enabled in environment');
      await this.router.navigate(['/']);
    }
  }

  private async authenticateWithKeycloak() {
    try {
      await firstValueFrom(this.securityService.initializeKeycloak());
      const isKeycloakAuthenticated = await this.keycloakService.isLoggedIn();
      const config = this.securityService.getConfig();

      if (isKeycloakAuthenticated || config.anonymousEnabled) {
        this.securityService.setKeycloakAdminMode(isKeycloakAuthenticated);
        // Keycloak users are always admins, redirect to admin home
        const targetRoute = isKeycloakAuthenticated ? '/admin/home' : '/';
        await this.router.navigate([targetRoute]);
      } else {
        await this.keycloakService.login();
      }
    } catch (error) {
      this.logger.error('Keycloak authentication error:', error);
    }
  }

  async retry() {
    await this.authenticateWithKeycloak();
  }
}
